import { useReportFilenameTemplateQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { ReportFilename } from '../../../../ReportFilenamesContext/types'
import { Spin } from 'antd'
import { useRefetchWithParent } from '../../../../../../hooks/useRefetchWithParent'
import { useReportFilenamesContext } from '../../../../ReportFilenamesContext'
import { useProjectContext } from 'context/ProjectContext'

const Template: React.FC<ReportFilename> = ({ id: reportId }) => {
  const { projectId } = useProjectContext()
  const { loading: parentLoading } = useReportFilenamesContext()
  const { data, loading, refetch } = useReportFilenameTemplateQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { projectId, reportId } },
  })
  useRefetchWithParent({ parentLoading, refetch })
  return (
    <Spin spinning={loading ?? false} size="small">
      {data?.reportFilenameTemplate}
    </Spin>
  )
}

export default Template
